module.exports = __webpack_public_path__ + "static/media/1.61169ed3.svg";